module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message_list clearfix p_background"
  }, [_c('h3', {
    staticClass: "all_title"
  }, [_vm._v("全部消息")]), _vm._v(" "), _c('section', {
    staticClass: "all_container container_box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status),
      expression: "status"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.status)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.status = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "all_state clearfix"
  }, [_c('div', {
    staticClass: "state_left"
  }, [_c('ul', [_c('li', {
    class: {
      msg_active: _vm.classFlag
    },
    on: {
      "click": function($event) {
        return _vm.getMessageList('')
      }
    }
  }, [_vm._v("全部消息")]), _vm._v(" "), _c('li', {
    class: {
      msg_active: _vm.classFlag1
    },
    on: {
      "click": function($event) {
        return _vm.getMessageList(0)
      }
    }
  }, [_vm._v("未读消息(" + _vm._s(_vm.msgCount) + ")")])])])]), _vm._v(" "), _c('div', {
    staticClass: "table_box table_a clearfix"
  }, [_c('table', {
    staticClass: "table table-hover text-center"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.page.content), function(message, index) {
    return _c('tr', [_c('td', [(message.messageStatus == 0) ? _c('span', {
      staticClass: "unread"
    }) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "cursor",
      on: {
        "click": function($event) {
          return _vm.view(message.id)
        }
      }
    }, [_vm._v(_vm._s(message.messageTitle))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("datetime")(message.messageSendTime)))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    class: _vm.page.totalPages > 0 ? 'show' : 'hidden'
  }, [_c('div', {
    staticClass: "row-fluid"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 20, 30, 40],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.page.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("消息标题")]), _vm._v(" "), _c('th', [_vm._v("发布时间")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-2d76011f"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/message_list.vue
// module id = 1243
// module chunks = 1